import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import {
  FaEnvelope,
  FaInstagram,
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "../App.css";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/category" },
  { label: "News", to: "/news" },
  { label: "Careers", to: "/career" },
  { label: "Contact", to: "/contact" },
];

const Footer = () => {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="g-4">
          <Col lg={5}>
            <Link to="/" className="site-footer-brand d-inline-flex mb-4">
              <Image src="/assets/logo.png" alt="BAS logo" />
            </Link>
            <p className="site-footer-copy mb-4">
              PT Bintang Anugerah Sukses is a medical equipment distribution
              company focused on dependable cath lab supply and responsive
              hospital support.
            </p>
            <div className="d-flex gap-3">
              <a
                href="https://www.instagram.com/bintanganugerahsukses?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="site-footer-social"
                aria-label="Instagram BAS"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/pt-bintang-anugerah-sukses/"
                target="_blank"
                rel="noopener noreferrer"
                className="site-footer-social"
                aria-label="LinkedIn BAS"
              >
                <FaLinkedin />
              </a>
            </div>
          </Col>

          <Col sm={6} lg={3}>
            <h2 className="site-footer-title">Quick Links</h2>
            <nav className="site-footer-links">
              {quickLinks.map((item) => (
                <Link key={item.to} to={item.to}>
                  {item.label}
                </Link>
              ))}
            </nav>
          </Col>

          <Col sm={6} lg={4}>
            <h2 className="site-footer-title">Contact</h2>
            <ul className="site-footer-contact list-unstyled mb-0">
              <li>
                <FaEnvelope />
                <span>Sales@pt-bas.com</span>
              </li>
              <li>
                <FaPhoneAlt />
                <span>+62 7306932</span>
              </li>
              <li>
                <FaMapMarkerAlt />
                <span>
                  Ruko Ubud Village Blok Kuta A No.25, Ciledug, Tangerang
                </span>
              </li>
            </ul>
          </Col>
        </Row>

        <div className="site-footer-bottom">
          <span>
            &copy; {new Date().getFullYear()} PT. Bintang Anugerah Sukses. All
            rights reserved.
          </span>
          <span>Modern medical equipment distribution</span>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
